import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { AppearanceEditor, type AppearanceValue } from './appearance-editor';
import { ZagButton } from '../button/button';
import { ZagIcon } from '../icon/icon';

export interface AppearanceEditDialogData {
  title: string;
  value: AppearanceValue;
  defaultIcon?: string;
  iconLabel: string;
  colorLabel: string;
  imageUrlLabel: string;
}

export interface AppearanceEditDialogResult {
  action: 'save' | 'cancel';
  value?: AppearanceValue;
}

@Component({
  selector: 'zag-appearance-edit-dialog',
  templateUrl: './appearance-edit-dialog.component.html',
  styleUrl: './appearance-edit-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, TranslatePipe, AppearanceEditor, ZagButton, ZagIcon],
})
export class AppearanceEditDialogComponent {
  protected readonly dialogRef = inject<DialogRef<AppearanceEditDialogResult>>(DialogRef);
  protected readonly data = inject<AppearanceEditDialogData>(DIALOG_DATA);

  protected readonly appearanceControl = new FormControl<AppearanceValue>(this.data.value, {
    nonNullable: true,
  });

  protected onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }

  protected onSave(): void {
    this.dialogRef.close({
      action: 'save',
      value: this.appearanceControl.value,
    });
  }
}
